import './locales/i18n'
import 'simplebar-react/dist/simplebar.min.css'
import 'react-lazy-load-image-component/src/effects/blur.css'
import 'react-credit-cards-2/dist/es/styles-compiled.css'
import './utils/custom.css'
import React from 'react'
import { BrowserRouter } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import { Toaster } from 'sonner'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import es from 'date-fns/locale/es'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import Router from './routes'
import ThemeProvider from './theme'
import ThemeLocalization from './locales'
import { ThemeSettings, SettingsProvider } from './components/settings'
import { MotionLazyContainer } from './components/animate'
import ScrollToTop from './components/scroll-to-top'
import { logoArt } from './utils/etc'
import { DomainProvider } from './contexts/DomainContext'

export default function App() {
  logoArt()
  return (
    <HelmetProvider>
      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={es}>
        <SettingsProvider>
          <ThemeProvider>
            <Toaster position="bottom-right" richColors closeButton />
            <BrowserRouter>
              <ScrollToTop />
              <MotionLazyContainer>
                <ThemeSettings>
                  <ThemeLocalization>
                    <DomainProvider>
                      <Router />
                    </DomainProvider>
                  </ThemeLocalization>
                </ThemeSettings>
              </MotionLazyContainer>
            </BrowserRouter>
          </ThemeProvider>
        </SettingsProvider>
      </LocalizationProvider>
    </HelmetProvider>
  )
}
